<script setup lang="ts">
import UserAvatar from '@/components/user-avatar/UserAvatar.vue';
import { useAuthStore } from '@/stores/auth.ts';
import UserAvatarGroup from '@/components/user-avatar/UserAvatarGroup.vue';
import { useSessionStore } from '@/stores/session.ts';
import { computed } from 'vue';
import { useSessionPanelsStore } from '@/stores/session-panels.ts';

const auth = useAuthStore();
const session = useSessionStore();
const sessionPanelsStore = useSessionPanelsStore();

const participants = computed(() => {
    return session.participants.filter((participant) => participant.id !== auth.user?.id);
});

const usersParticipant = computed(() => {
    return session.participants.find((participant) => participant.id === auth.user?.id);
});
</script>

<template>
    <div class="p-1 w-60">
        <div
            class="w-full flex justify-between gap-4 p-1 items-center rounded-xl hover:bg-surface-ghost-hover select-none"
            @click="sessionPanelsStore.toggleUsersPanel"
        >
            <UserAvatar v-if="usersParticipant" :participant="usersParticipant"></UserAvatar>
            <UserAvatarGroup :participants="participants">Others</UserAvatarGroup>
        </div>
    </div>
</template>
